const path = "/_Customer/Messenger";
export const ReadChannel = path + "/ReadChannel";
export const ReadChannelContent = path + "/ReadChannelContent";
export const ReadPagingChannelContent = path + "/ReadPagingChannelContent";
export const GetOneRecordChannelContent = path + "/GetOneRecordChannelContent";
export const ReadChannelContentAttachment =
  path + "/ReadChannelContentAttachment";
